import React, { useState } from "react";
import Navbar from "../components/Navbar";
import "../styles/landing.scss";

export default function Landing() {
     const [inputValue, setInputValue] = useState("");

     // const submitForm = (e) => {
     //   e.preventDefault();
     //   let url =
     //     "https://getmollo.us1.list-manage.com/subscribe/post?u=2c175cae252d22c58fa9b5e2c&amp;id=0582b30931";
     //   fetch(url, {
     //     method: "POST",
     //     headers: {
     //       "Content-type": "application/json; charset=UTF-8",
     //       "access-control-allow-origin" : "*",
     //       "access-control-allow-headers": "content-type"
     //     },
     //     mode: "cors",
     //     body: JSON.stringify({
     //       email: inputValue.toString(),
     //     }),
     //   })
     //     .then((data) => console.log(data))
     // };

     return (
          <>
               <Navbar />
               <div className="header-container">
                    <div className="left-side">
                         <div className="header-heading">
                              The future of <br /> digital payments.
                         </div>

                         <div className="header-text">Unleash the power of money. All of your bills, money transfers and high-interest savings can be done in one place.</div>

                         <form
                              method="post"
                              action="https://getmollo.us1.list-manage.com/subscribe/post?u=2c175cae252d22c58fa9b5e2c&amp;id=0582b30931"
                              id="subscriberForm"
                              // onSubmit={submitForm}
                         >
                              <div className="cta-container">
                                   <input type="email" name="EMAIL" placeholder="Your Email Address Here" required value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
                                   <input type="submit" id="formSubmit" value="Get Early Access" />
                              </div>
                         </form>

                         <hr
                              style={{
                                   height: "1px",
                                   backgroundColor: "#ccc",
                                   border: "none",
                                   margin: "1.5rem 0",
                              }}
                         />

                         <div className="stats">
                              <span>1,469</span> users already on the waiting list
                         </div>
                    </div>

                    <div className="right-side"></div>
               </div>
          </>
     );
}

window.addEventListener("scroll", () => {
     var offset = window.pageYOffset;
     if (offset > 1) {
          window.document.querySelector(".navbar-container").classList.add("scroll");
     } else if (offset < 1) {
          window.document.querySelector(".navbar-container").classList.remove("scroll");
     }
});
